<template>
<ul class="question-item" :class="{checkbox:subjectType === 2}">
  <li class="title">{{subjectNo}}.【<span v-if="subjectType === 1">单选</span><span v-if="subjectType === 2">多选
      </span>】({{points}}分){{title}}</li>
  <li class="opt" v-for=" (item, index) in options " :key="index" :class="{on : item.checkFlag === 1 }">{{item
    .content}}</li>
  <li><span class="answer">正确答案:</span>{{answer}}</li>
</ul>
</template>

<script>
export default {
  props: ['title', 'options', 'points', 'subjectType', 'subjectNo'],
  computed: {
    answer () {
      let r = []
      this.options.forEach(item => {
        item.correctAnswer && r.push(item.content)
      })
      return r.join(',')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.question-item {
  background-color: #fff;
  border: 1PX solid $ucar_light_border;
  border-radius: 10px;
  padding: 20px 30px 0;
  margin-bottom: 30px;
  > li {
    box-sizing: border-box;
    color: $ucar_font_assist_color;
    font-size: $ucar_font_h3;
    margin-bottom: 40px;
    &.title {
      font-size: $ucar_font-h3-5;
      color: $ucar_font_color;
      border-bottom: 1PX solid $ucar_light_border;
      padding-bottom: 20px;
    }
    &.opt {
      padding-left: 60px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 6px;
        left: 0;
        width: 34px;
        height: 34px;
        background: url("../assets/icon_radio.png") no-repeat 100%/100%;
        -webkit-background-size: contain;
        background-size: contain;
      }
      &.on::before {
        background: url("../assets/icon_radio_checked.png") no-repeat 100%/100%;
        -webkit-background-size: contain;
        background-size: contain;
      }
    }
    .answer {
      color: $ucar_label_color;
    }
  }
  &.checkbox > li {
    &.opt::before {
      background: url("../assets/icon_checkbox.png") no-repeat 100%/100%;
      -webkit-background-size: contain;
      background-size: contain;
    }
    &.opt.on::before {
      background: url("../assets/icon_checkbox_checked.png") no-repeat 100%/100%;
      -webkit-background-size: contain;
      background-size: contain;
    }
  }
}
</style>